import oficialmicrositio from "./oficialmicrositio/oficialmicrositio"
import altadecontenidomicrositio from "./altadecontenidomicrositio/altacontenidomicrositio"
import edicioncontenidomicrositio from "./edicioncontenidomicrositio/edicioncontenidomicrositio"
import busquedadecontenido from "./busquedadecontenido/busquedadecontenido"
import comunicadosmicrositios from "./comunicadosmicrositios/comunicadosmicrositios"
import permisosmicrositios from "./permisosmicrositios/permisosmicrositios"

const micrositioweb = {
    oficialmicrositio: oficialmicrositio,
    altadecontenidomicrositio: altadecontenidomicrositio,
    edicioncontenidomicrositio:edicioncontenidomicrositio,
    busquedadecontenido:busquedadecontenido,
    comunicadosmicrositios: comunicadosmicrositios,
    permisosmicrositios: permisosmicrositios
}

export default micrositioweb;


//////////////////
// WEBPACK FOOTER
// ./static/js/api/SICPO/sistema/micrositioweb/micrositioweb.js
// module id = null
// module chunks = 